import React from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '20px',
    margin: theme.spacing(3, 0, 2)
  }
}));

const GeneralButton = ({ children, ...props }) => {
  const styles = useStyles();

  return (
    <Button variant="contained" fullWidth color="primary" className={styles.root} {...props}>
      {children}
    </Button>
  );
};

export default GeneralButton;
